import { useCallback } from 'react';
import { FormatNumberOptions, useIntl } from 'react-intl';

export type LocalizePercentageOptions = Omit<FormatNumberOptions, 'style'> & { showWithoutSymbol?: boolean };

export const useLocalizePercentage = () => {
    const intl = useIntl();

    return useCallback(
        (value: number, options?: LocalizePercentageOptions) =>
            intl.formatNumber(options?.showWithoutSymbol ? value * 100 : value, {
                style: options?.showWithoutSymbol ? undefined : 'percent',
                ...options,
            }),
        [intl]
    );
};
